const testimonials = [
  {
    name: "John Doe",
    company: "ABC Corporation",
    text: "The platform transformed how our employees learn and develop new skills.",
  },
  {
    name: "Sarah Lee",
    company: "XYZ Group",
    text: "AI recommendations make the learning experience much more engaging.",
  },
];

export default function Testimonials() {
  return (
    <section className="bg-slate-900 py-28">

      <div className="container mx-auto px-6">

        <div className="text-center mb-16">

          <h2 className="text-5xl font-bold text-white">

            What Clients Say

          </h2>

        </div>

        <div className="grid md:grid-cols-2 gap-8">

          {testimonials.map((item) => (

            <div
              key={item.name}
              className="rounded-3xl border border-white/10 bg-slate-950 p-8"
            >

              <p className="text-slate-400 leading-8">

                "{item.text}"

              </p>

              <div className="mt-8">

                <h4 className="text-white font-semibold">

                  {item.name}

                </h4>

                <p className="text-cyan-400">

                  {item.company}

                </p>

              </div>

            </div>

          ))}

        </div>

      </div>

    </section>
  );
}